import script from "./dynamic-ellipsis.vue?vue&type=script&setup=true&lang=js"
export * from "./dynamic-ellipsis.vue?vue&type=script&setup=true&lang=js"

import "./dynamic-ellipsis.vue?vue&type=style&index=0&id=20960c8c&lang=less"

const __exports__ = script;

export default __exports__